<template>
  <!--弹框6 开始-->
  <el-dialog :visible.sync="hotelRoomPriceDetailDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" custom-class="price-title-data-dialog" center style="text-align: center;" :before-close="showCloFun">
    <div class="price-title-data-detail" style="width:100%;">
      <div class="price-title-data-detail-top">
        <div class="price-title-data-detail-center">
          {{$t('priceDetails')}}
        </div>
      </div>
      <div class="price-title-data-detail-body">
        <div>
          <!-- price -->
          <div class="price-title-data-detail-line">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{searchPriceData.roomcount}}{{$t('onOurSite')}} x {{searchPriceData.nightCount}}{{$t('night')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                {{price.currency}} {{price.fareTotal}}
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('avgNight')}} {{price.currency}} {{price.fare}}</span>
            </div>
          </div>
          <!-- tax -->
          <div class="price-title-data-detail-line">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('taxesFees')}}</span>
                <el-popover popper-class="popverText" placement="top-start" width="327" offset="99" trigger="click" v-if="language === 'en'">
                  <div style="font-size:8px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                  <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                </el-popover>
                <el-popover popper-class="popverText" placement="top-start" width="327" offset="44" trigger="click" v-else>
                  <div style="font-size:8px;"><span v-if="source == 'google'">{{$t('taxesFeesGoogle')}}</span><span v-else>{{$t('taxesAndServiceFees')}}</span></div>
                  <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; vertical-align: middle;" slot="reference">
                </el-popover>
              </div>
              <div class="price-title-data-detail-line-right">
                {{price.currency}} {{price.curTax}}
              </div>
            </div>
          </div>
          <!-- payableAtProperty -->
          <div class="price-title-data-detail-line" v-if="price.mandatoryFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('mandatoryFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.mandatoryFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.mandatoryFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.mandatoryTax !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('mandatoryTax')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.mandatoryTax}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.mandatoryTax !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.resortFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('resortFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.resortFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.resortFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.cityFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('cityTaxFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.cityFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.cityFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.destinationFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('destinationFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.destinationFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.destinationFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.serviceFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('serviceFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.serviceFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.serviceFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.CleaningFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('cleaningFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.CleaningFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.CleaningFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
          <div class="price-title-data-detail-line" v-if="price.administrativeFee !== ''">
            <div class="price-title-data-detail-center">
              <div class="price-title-data-detail-line-left">
                <span>{{$t('administrativeFee')}}</span>
              </div>
              <div class="price-title-data-detail-line-right">
                <span>{{price.administrativeFee}}</span>
              </div>
            </div>
          </div>
          <div class="price-title-data-detail-min" v-if="price.administrativeFee !== ''">
            <div class="price-title-data-detail-center font-min">
              <span>{{$t('payableAtProperty')}}</span>
            </div>
          </div>
        </div>

        <!-- Total Price -->
        <div class="price-title-data-detail-line">
          <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
            <div class="price-title-data-detail-line-left">
              <span>{{$t('totalPrice')}}</span>
            </div>
            <div class="price-title-data-detail-line-right">
              {{price.currency}} {{price.totalPrice}}
            </div>
          </div>
        </div>
        <div class="price-title-data-detail-min" :class="{'price-padding': price.payPriceShow === false || price.payPriceShow === 'false'}">
          <div class="price-title-data-detail-center font-min">
            <span>{{$t('includesTaxesFees')}}</span>
          </div>
        </div>
        <!-- Pay Now -->
        <div class="price-title-data-detail-line" style="padding-bottom:20px;" v-if="price.payPriceShow === true || price.payPriceShow === 'true'">
          <div class="price-title-data-detail-center" style="font-weight: 550;font-size: 16px;">
            <div class="price-title-data-detail-line-left">
              <span>{{$t('payNow')}}</span>
            </div>
            <div class="price-title-data-detail-line-right">
              {{price.currency}} {{price.payPrice}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <!--弹框6 结束-->
  <!--引入方式-->
  <!-- <frameLast :hotelRoomPriceDetailDialog="hotelRoomPriceDetailDialog" :priceDetailData="priceDetailData"></frameLast> -->
</template>

<script>
export default {
  name: 'hotelRoomPriceDetail',
  props: ['hotelRoomPriceDetailDialog', 'searchPriceData', 'priceDetailData', 'source', 'language'],
  data () {
    return {
      frameWidth: '450px',
      showClo: true,
      price: {}
    }
  },
  watch: {
    priceDetailData: function (news, olds) {
      this.price = news
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    showCloFun: function () {
      var submitInfo = {'click': 1}
      this.$emit('hotelRoomPriceDetailCloseFun', submitInfo)
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog{border-radius: 5px;}
/deep/ .el-dialog__header{padding:0px!important;}
/deep/ .el-dialog__body{padding:0px!important;}
/deep/ .el-dialog__headerbtn{padding: 14px; right:6px; top:0px;}
.price-title-data-dialog .price-title-data-detail-top{border-radius: 2px;}
.price-title-data-dialog .price-title-data-detail-top{width:100%; height:40px;background:#4F4C4C;color:#fff;border-top-left-radius: 5px;border-top-right-radius: 5px;line-height:40px;}
.price-title-data-dialog .price-title-data-detail-center{width:92%;margin:0 auto;}
.price-title-data-dialog .price-title-data-detail-body{width:100%;}
.price-title-data-dialog .price-title-data-detail-line{width:100%;height:20px;/*line-height:40px;*/font-size:14px;padding-top:20px;}
.price-title-data-dialog .price-title-data-detail-min{width:100%;height:20px;line-height:20px;}
.price-title-data-dialog .price-title-data-detail-line .price-title-data-detail-line-left{width:50%;height:100%;float:left;text-align:left;}
.price-title-data-dialog .price-title-data-detail-line .price-title-data-detail-line-left .zhu-cont{display: block;line-height: 30px;}
.price-title-data-dialog .price-title-data-detail-line .price-title-data-detail-line-left .avgprice{display: block;font-size: 12px;line-height: 0px;color: #838383;}
.price-title-data-dialog .font-min{font-size: 12px;color:#838383;}
.price-title-data-dialog .price-title-data-detail-line .price-title-data-detail-line-right{width:50%;height:100%;float:right;text-align:right;}
.price-padding{padding-bottom:20px;}
@media screen and (max-width: 1000px) {
.dialog-gohome{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/hotelRoomPriceDetail.vue